<div style="background: url(/assets/images/backgrounds/BG-001.png) no-repeat; background-size: cover; width: 100%;"
  fxLayout="row" fxLayoutAlign="start">
  <div class="card" style="display: flex;flex-direction: column; flex:1; justify-content: center;align-items: center;">
    <mat-card *ngIf="!showResult" fxLayout="column" fxLayoutAlign="center">
      <form (ngSubmit)="onSubmit()" [formGroup]="aFormGroup">
        <div style="margin-bottom: 16px;">
          <ngx-recaptcha2 *ngIf="showCaptcha" siteKey="6Lc3QDQaAAAAAHc14iyTzg1dQKvZrxib2DTL5_tF" (reset)="handleReset()"
            (expire)="handleReset()" (success)="resolved($event)" hl="ta" [useGlobalDomain]="false"
            formControlName="recaptcha">
          </ngx-recaptcha2>
        </div>

        <div *ngIf="showError" style="margin-bottom:16px;display:flex;flex-direction:row;justify-content:center;">
          <mat-error>{{errorMsg | translate}}</mat-error>
        </div>

        <div style="display:flex;flex-direction:row;justify-content:center;">
          <button *ngIf="!loading" [disabled]="!enableDoneBtn" mat-raised-button color="accent" class="submit-button"
            type="submit" aria-label="LOGIN">
            சரிபார்க்கவும்
          </button>
          <mat-spinner diameter="50" *ngIf="loading"></mat-spinner>
        </div>
      </form>
    </mat-card>

    <div *ngIf="showResult" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
      <table id="t01">
        <tr>
          <td style="text-align: center;" colspan="2">
            <img style="max-width: 150px;" (error)="errorHandler($event)" src={{party_post_data?.member_photo_url}}
              alt="No Image">
          </td>
        </tr>
        <tr>
          <th>{{'Member Name' | translate}}</th>
          <td>{{party_post_data?.member_name}}</td>
        </tr>
        <tr>
          <th>{{'Member Id' | translate}}</th>
          <td>{{party_post_data?.member_id}}</td>
        </tr>
        <tr>
          <th>{{'Post' | translate}}</th>
          <td>{{party_post_data?.party_post_subgroup_name | translate}}</td>
        </tr>
        <tr>
          <th>{{'Section' | translate}}</th>
          <td>{{party_post_data?.flow_path}}</td>
        </tr>
        <tr>
          <th>{{'Post Start Date' | translate}}</th>
          <td>{{party_post_data?.start_date | date:'dd-MM-yyyy'}}</td>
        </tr>
        <tr>
          <th>{{'Post End Date' | translate}}</th>
          <td>{{party_post_data?.end_date | date:'dd-MM-yyyy'}}</td>
        </tr>
        <tr>
          <th>{{'Post Status' | translate}}</th>
          <td>{{party_post_data?.status == 98 ? 'பொறுப்பில் தற்போது உள்ளார்' : 'பொறுப்பில் தற்போது இல்லை'}}</td>
        </tr>
      </table>
      <!-- <button style="margin-top:16px;" [disabled]="!enableDoneBtn" mat-raised-button color="accent"
        class="submit-button" (click)="onBack();">
        பின்னே செல்க
      </button> -->
    </div>
  </div>
</div>